import { Link, useParams } from "react-router-dom";
import { APP_ROUTES } from "../../routes";

export default function IntentPlans() {
  const { id: projectId = "" } = useParams<{ id: string }>();

  return (
    <div className="manifold-page">
      <header className="manifold-page-header">
        <p className="sg-section-kicker">Pillar A · Cloud Intelligence Core</p>
        <h1>Intent Plans</h1>
        <p className="text-muted">
          Long-horizon spatial plans synthesised by the Managed Agents
          planner against this project&rsquo;s world twin. Plans become
          training scenarios for the sim engine and are signed into the
          Compliance Ledger before they reach hardware.
        </p>
      </header>

      <section className="manifold-empty">
        <h2>No intent plans yet</h2>
        <p>
          Once the cognition-service is wired to the Managed Agents
          endpoint, drafted plans will appear here with their subgoals,
          geometry references, and approval state.
        </p>
        <Link to={APP_ROUTES.project(projectId)} className="sg-btn sg-btn-secondary">
          Back to project
        </Link>
      </section>
    </div>
  );
}
